module.exports = __webpack_public_path__ + "static/media/graph-autoscale.3d82d6bd.svg";